import moment from 'moment'
import type { RangeKey } from '@dataTypes/dashboard.types'
import { CALENDAR_DATE_FORMAT } from '@utils/dashboardFinance.util'

export const VALID_DASHBOARD_DETAIL_RANGES: readonly RangeKey[] = [
  '1D',
  '1W',
  '1M',
  '1Y',
  'YTD',
] as const

const VALID_RANGE_SET = new Set<string>(VALID_DASHBOARD_DETAIL_RANGES)

export function parseDashboardDetailRange(
  params: URLSearchParams,
  fallback: RangeKey = '1D',
): RangeKey {
  const r = params.get('range')
  if (r && VALID_RANGE_SET.has(r)) return r as RangeKey
  return fallback
}

export function parseDashboardDetailDate(
  params: URLSearchParams,
  fallbackDisplayDate: string,
): string {
  const d = params.get('date')
  if (d && moment(d, 'YYYY-MM-DD', true).isValid()) {
    return moment(d, 'YYYY-MM-DD').format(CALENDAR_DATE_FORMAT)
  }
  return fallbackDisplayDate
}

export function formatDashboardDetailDateQuery(displayDate: string): string {
  return moment(displayDate, CALENDAR_DATE_FORMAT).format('YYYY-MM-DD')
}

export function patchDashboardDetailSearchParams(
  current: URLSearchParams,
  patch: Record<string, string>,
): URLSearchParams {
  const next = new URLSearchParams(current)
  Object.entries(patch).forEach(([k, v]) => {
    next.set(k, v)
  })
  return next
}
